import React from 'react';
import PropTypes from 'prop-types';

export default class Property extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string
    };

    render() {
        const {title, description} = this.props;
        return (
            <div className="feature-item">
                <h4>{title}</h4>
                <p>{description}</p>
            </div>
        );
    }
}
